// src/components/Assets/AssetPermissions/PermissionStatusBadge.js
// Status badge component with color coding

import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getPermissionStatus, getLocalizedStatusLabel } from "../models";
import "./PermissionStyles.css";

const PermissionStatusBadge = ({ status }) => {
  const [, { language }] = useTranslation();

  const statusConfig = getPermissionStatus(status);
  const label = getLocalizedStatusLabel(status, language);

  return (
    <span
      className="status-badge"
      style={{
        backgroundColor: statusConfig.bgColor,
        color: statusConfig.color
      }}
    >
      {label}
    </span>
  );
};

// PropTypes validation
PermissionStatusBadge.propTypes = {
  status: PropTypes.string.isRequired
};

export default PermissionStatusBadge;
